module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "modal modal-confirm align-baseline is-active borderless"
  }, [(_vm.backdrop) ? _c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.backdropClose
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "modal-card",
    style: (_vm.modalWidth)
  }, [(_vm.showHeader) ? _c('header', {
    staticClass: "modal-card-head"
  }, [_vm._t("header", [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("×")])])], 2) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('article', {
    staticClass: "media",
    class: [_vm.typeClass]
  }, [(_vm.icon) ? _c('div', {
    staticClass: "media-left"
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.iconClass]
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_vm._v(_vm._s(_vm.content))])])]), _vm._v(" "), (_vm.showFooter) ? _c('footer', {
    staticClass: "modal-card-foot"
  }, [_vm._t("footer", [(_vm.showCancel) ? _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]) : _vm._e(), _vm._v(" "), (_vm.showOk) ? _c('a', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.okText))]) : _vm._e()])], 2) : _vm._e()])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bd634248!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/message-modal/MessageModal.vue
// module id = 355
// module chunks = 0